export default (state, props) => {
  if (state[props.reduxEntity] && state[props.reduxEntity].active) {
    return state[props.reduxEntity].pendingChanges;
  }
  return false;
};